import { Document, Page, Text, StyleSheet, View, pdf } from '@react-pdf/renderer';
import { decode } from 'html-entities';
import { FULL_NAME, saveAs } from 'helpers/common';
import moment from 'moment';
import { getDataAnalysisProrityReportsV1} from 'store/services/clientDataReportsService';
import { useShowLoader } from 'hooks/useShowLoader';
import { Button } from 'react-bootstrap';

import { ReactComponent as DownloadIcn } from "Assets/Images/icn/download.svg";

const styles = StyleSheet.create({
  page: { backgroundColor: '#fff', flexDirection: "column", fontSize: "10px", padding: "20px" },
  pageHeader: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: "5px",
  },
  clientName: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: "15px",
    backgroundColor: "#ddd",
    padding: "5px",
    borderTop: "2px solid #bbb",
  },
  tableContainer: {
    marginTop: "15px",
    paddingBottom: "15px",
    // borderBottom: "2px solid #ccc",
    // width: "100%"
  },
  disclaimer: {
    fontSize: "8px",
    flexDirection: "row",
    justifyContent: "space-between",
    marginTop: "15px",
  },
  tableOuter: {
    marginTop: "15px"
  },
  tableHeading: {
    fontSize: "12px",
    fontWeight: "bold",
    fontFamily: "Helvetica-Bold",
    color: "#08415c",
    borderBottom: "2px solid #ccc"
  },
  sectionHeading: {
    fontSize: "18px",
    fontWeight: "bold",
    fontFamily: "Helvetica-Bold",
    color: "#08415c",
    marginTop: "15px",
    // borderBottom: "2px solid #ccc"
  },
  notesContainer: {
    padding: "0px 10px 5px 5px",
    marginBottom: "5px",
    fontSize: "9px",
    backgroundColor: "#eee",
    width: "100%"
  },
  noteHeading: {
    textDecoration: "underline",
    marginTop: "5px",
  },
  noteText: {
    padding: 0,
    margin: 0,
  }
});

const tableStyles = StyleSheet.create({
  table: {
    flexDirection: "row",
    flexWrap: "wrap",
  },
  row: {
    flexDirection: "row",
    alignItems: "start",
    // padding: "10px"
  },
  headerCell: {
    color: "#000",
    fontSize: "10px",
    fontWeight: "bold",
    fontFamily: "Helvetica-Bold",
    width: "25%",
    padding: "5px",
    paddingTop: "1px",
    paddingBottom: "1px",
    flexWrap: "wrap",
    alignSelf: "flex-end",
    borderBottom: "2px solid #ccc",
  },
  cell: {
    color: "#000",
    fontSize: "9px",
    // fontWeight: "bold",
    // fontFamily: "Helvetica-Bold",
    width: "25%",
    padding: "5px",
    flexWrap: "wrap",
    borderBottom: "1px solid #ccc",
  },
});

const DownloadPriorityCompReportPDF = ({ client, date, naqList, todoIds, label, type }) => {

  const showLoader = useShowLoader();

  const downloadPDFReport = async () => {
    try {
      showLoader(true);
      const priorityReport = await getNAQv1PriorityReportCompData(todoIds, client);
      // const todoNotes = await getNotes(todoId);

      let colors = [];
      let naq1 = priorityReport?.prevTodoId;
      let naq2 = priorityReport?.currentTodoId;
      colors.push(naqList?.find(naq => naq.id == naq1)?.color);
      colors.push(naqList?.find(naq => naq.id == naq2)?.color);

      const doc = 
        <NAQ1PriorityCompDoc
          priorityReport={priorityReport}
          client={client}
          date={date}
          type={type}
          naqList={naqList}
          colors={colors}
        />;
      const asPdf = pdf([]); // {} is important, throws without an argument
      asPdf.updateContainer(doc);
      const blob = await asPdf.toBlob();
      saveAs(blob, 'Priority-Report.pdf');
      showLoader(false);
    } catch(err) {
      console.log("Error downloading report", err);
      showLoader(false);
    }
  }

  return (
    <Button
      onClick={downloadPDFReport}
      className="d-flex align-items-center justify-content-center commonBtn btnSm"
    >
      <span className="icn me-2">
        <DownloadIcn />
      </span>
      {label}
    </Button>
  )
}


export const NAQ1PriorityCompDoc = ({ priorityReport, notes, client, date, type, naqList, colors }) => {
  
  let dataPart1 = priorityReport?.data?.part1;
  let dataPart2 = priorityReport?.data?.part2;
  return (
    <Document>

      {/* PAGE 1 */}
      {/* Potential Conditions */}
      <Page style={styles.page}>

        <View style={styles.pageHeader}>
          <Text style={{fontSize: "18px", fontWeight: "bold", fontFamily: "Helvetica-Bold", color: "#08415c"}}>
            Priority Comparision Report
          </Text>
          <Text style={{fontSize: "22px", fontWeight: "bold", fontFamily: "Helvetica-Bold", color: "#08415c"}}>
            Nutri-Q
          </Text>
        </View>

        <View style={styles.clientName}>
          <Text>
            Client: {FULL_NAME(client.first_name, client.last_name)}
          </Text>
          <Text>
            {moment(date).format("MMM DD, YYYY")}
          </Text>
        </View>
        {dataPart1 && (
          <View>
            <Text style={styles.sectionHeading}>
              Part 1
            </Text>
            <View style={styles.tableOuter}>
              <Text style={styles.tableHeading}>
                Improved ({dataPart1.improved?.length || ""})
              </Text>
              <View style={styles.tableContainer}>
                <PriorityTable
                  questions={dataPart1.improved}
                  priorityReport={priorityReport}
                  colors={colors}
                />
              </View>
            </View>
            <View style={styles.tableOuter}>
              <Text style={styles.tableHeading}>
                Worsened ({dataPart1.worsened?.length || ""})
              </Text>
              <View style={styles.tableContainer}>
                <PriorityTable
                  questions={dataPart1.worsened}
                  priorityReport={priorityReport}
                  colors={colors}
                />
              </View>
            </View>
            <View style={styles.tableOuter}>
              <Text style={styles.tableHeading}>
                Unchanged ({dataPart1.unchanged?.length || ""})
              </Text>
              <View style={styles.tableContainer}>
                <PriorityTable
                  questions={dataPart1.unchanged}
                  priorityReport={priorityReport}
                  colors={colors}
                />
              </View>
            </View>
          </View>
        )}

        {dataPart2 && (
          <View>
            <Text style={styles.sectionHeading}>
              Part 2
            </Text>
            <View style={styles.tableOuter}>
              <Text style={styles.tableHeading}>
                Improved ({dataPart2.improved?.length || ""})
              </Text>
              <View style={styles.tableContainer}>
                <PriorityTable
                  questions={dataPart2.improved}
                  priorityReport={priorityReport}
                  colors={colors}
                />
              </View>
            </View>
            <View style={styles.tableOuter}>
              <Text style={styles.tableHeading}>
                Worsened ({dataPart2.worsened?.length || ""})
              </Text>
              <View style={styles.tableContainer}>
                <PriorityTable
                  questions={dataPart2.worsened}
                  priorityReport={priorityReport}
                  colors={colors}
                />
              </View>
            </View>
            <View style={styles.tableOuter}>
              <Text style={styles.tableHeading}>
                Unchanged ({dataPart2.unchanged?.length || ""})
              </Text>
              <View style={styles.tableContainer}>
                <PriorityTable
                  questions={dataPart2.unchanged}
                  priorityReport={priorityReport}
                  colors={colors}
                />
              </View>
            </View>
          </View>
        )}

        {/* {(priorityReport && priorityReport?.length > 0) &&
          <View style={styles.tableContainer}>
            <PriorityTable items={priorityReport} />
          </View>
        } */}

        {/* Disclaimer */}
        <View style={styles.disclaimer}>
          <Text style={{ width: "90%" }}>
            Statements made on this document and reference materials have not been evaluated by the Food and Drug Administration.
            These products or protocols are not intended to diagnose, treat, cure or prevent any disease or be used as a substitute for appropriate care of a qualified health practitioner. 
          </Text>
          <Text>
            {moment().format("MMM DD, YYYY")}
          </Text>
        </View>
      </Page>
    </Document>
  )
}

export const getNAQv1PriorityReportCompData = async (todoIds, client) => {
  try {
    if (!todoIds) {
      throw new Error("Invalid ToDo ID");
    }
    let data = {
      values: {
        todoIds
      },
      clientId: client.id
    };
    const response = await getDataAnalysisProrityReportsV1(data);
    if (response.success === true) {
      return response.body;
    }
    return false;
  } catch (err) {
    console.log(err);
    return false;
  }
}

const PriorityTable = ({ questions, priorityReport, colors }) => {
  const rows = questions && questions.map((question, i) => {
    if(!question) {
      return null;
    }
    return (
      <>
        <View style={[tableStyles.row]} key={i}>
        <Text style={[tableStyles.cell, {width: "15%"}]}>{`${decode(question.page_title)}`}</Text>
          <Text style={[tableStyles.cell, {width: "25%"}]}>{`${decode(question.question)}`}</Text>
          <Text style={[tableStyles.cell, {width: "25%"}]}>{decode(question?.answer_prev)}</Text>
          <Text style={[tableStyles.cell, {width: "25%"}]}>{decode(question?.answer_current)}</Text>
          <Text style={[tableStyles.cell, {width: "10%"}]}>{(question.scoreChange <= 0 ? "" : "+") + question.scoreChange}</Text>
        </View>
      </>
    )
  });
  
  return (
    <View style={tableStyles.table}>
      <View style={tableStyles.row}>
        <Text style={[tableStyles.headerCell, {width: "40%"}]}></Text>
        <Text style={[tableStyles.headerCell, {width: "25%", borderBottom: `4px solid ${colors && colors[0]}`}]}>{moment(priorityReport.prevCompletedAt).format("MMM DD, YYYY")}</Text>
        <Text style={[tableStyles.headerCell, {width: "25%", borderBottom: `4px solid ${colors && colors[1]}`}]}>{moment(priorityReport.currentCompletedAt).format("MMM DD, YYYY")}</Text>
        <Text style={[tableStyles.headerCell, {width: "10%"}]}></Text>
      </View>
      <View style={tableStyles.row}>
      <Text style={[tableStyles.headerCell, {width: "15%"}]}>Section</Text>
        <Text style={[tableStyles.headerCell, {width: "25%"}]}>Question</Text>
        <Text style={[tableStyles.headerCell, {width: "25%"}]}>Answer</Text>
        <Text style={[tableStyles.headerCell, {width: "25%"}]}>Answer</Text>
        <Text style={[tableStyles.headerCell, {width: "10%"}]}>Change</Text>
      </View>
      {rows}
    </View>
  )
};

export default DownloadPriorityCompReportPDF;